'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FacebookLoginApiHelper = function () {
    function FacebookLoginApiHelper() {
        _classCallCheck(this, FacebookLoginApiHelper);

        this.isReady = false;
        this.queue = [];
    }

    FacebookLoginApiHelper.prototype.clearQueue = function clearQueue() {
        this.queue.forEach(function (callback, params) {
            callback.apply(undefined, params);
        });
    };

    FacebookLoginApiHelper.prototype.loadFbLoginApi = function loadFbLoginApi() {
        var _this = this;

        var facebookAppId = require('../config').urls.facebookAppId;
        // facebook documentation - https://developers.facebook.com/docs/facebook-login/web
        window.fbAsyncInit = function () {
            FB.init({
                appId: facebookAppId,
                cookie: true,
                xfbml: true,
                version: 'v2.8'
            });

            _this.clearQueue();
            _this.isReady = true;
        };

        // Loading the facebook SDK asynchronously
        (function (d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s);js.id = id;
            js.src = "//connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, 'script', 'facebook-jssdk');
    };

    FacebookLoginApiHelper.prototype.loginWithFacebook = function loginWithFacebook(successCallback, failureCallback) {
        if (!this.isReady) {
            this.queue.push({
                callback: this,
                params: { successCallback: successCallback, failureCallback: failureCallback }
            });
        } else {
            try {
                FB.login(function (res) {
                    if (res.status === 'connected') {
                        successCallback(res.authResponse.accessToken);
                    } else {
                        console.log('error logging into facebook');
                        failureCallback();
                    }
                }, { scope: 'email' });
            } catch (err) {
                console.log('FB err..', err);
                failureCallback();
            }
        }
    };

    return FacebookLoginApiHelper;
}();

module.exports = new FacebookLoginApiHelper();


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/social/FacebookLoginApiHelper.js
// module id = 191
// module chunks = 0